/* @indexer:no-export */
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
export default function EmptyTable(_ref) {
  var className = _ref.className,
    children = _ref.children,
    i18n = _ref.i18n,
    i18nKey = _ref.i18nKey;
  return /*#__PURE__*/React.createElement("div", {
    className: "dm-table__cell dm-table__cell--empty"
  }, /*#__PURE__*/React.createElement(FormattedMessage, Object.assign({
    id: i18nKey
  }, i18n)));
}